import Loading from "../../components/loading";

export default function HideScreen({ message }) {
  return <Loading $marginTop="40px" $message={message} />;
}
